import { AppButton } from "@/shared/Components";
import { ChevronIcon } from "@/shared/icons";
import type { FC } from "react";
import styles from "./styles.module.scss";

type Props = {
  backArrow?: boolean;
  onClick?: () => void;
  title?: string;
};

export const Title: FC<Props> = ({ backArrow, onClick, title }) => {
  return (
    <AppButton disabled={!onClick} onClick={onClick} className={styles.root}>
      {backArrow && <ChevronIcon />}
      {title}
    </AppButton>
  );
};
